import { render, staticRenderFns } from "./AggreMenu.vue?vue&type=template&id=232ce340"
import script from "./AggreMenu.vue?vue&type=script&lang=js"
export * from "./AggreMenu.vue?vue&type=script&lang=js"
import style0 from "./AggreMenu.vue?vue&type=style&index=0&id=232ce340&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports